import React from "react";
import Weather from "./Weather";
import "./App.css";

function App() {
  return (
    <div className="App">
      <div className="container">
        <Weather defaultCity="Moscow" />
        <p className="note">
          This project was coded by{" "}
          <a
            href="https://www.linkedin.com/in/ekaterina-drozdova-602993191/"
            target="_blank"
          >
            Katia
          </a>{" "}
          and it is{" "}
          <a
            href="https://github.com/Katerina-spb/weather-app-react-new.git"
            target="_blank"
          >
            open-soursed on GitHub
          </a>
        </p>
      </div>
    </div>
  );
}

export default App;
